import validation from "./validation-i18n"

export default {
    validation
}